import { AnimatePresence, motion, Variants } from 'framer-motion';
import { Link } from 'react-router-dom';
import Button from '../../../../Components/Button';
import { ReactComponent as CloseIco } from '../../../../assets/svg/utils/close.svg';
import CoinGroupWithGlow from '../../../../assets/images/coin/coin-group-with-glow.png';
import Pages from '../../../../Router/pages';

type TNotEnoughFundsModalProps = {
    open: boolean;
    onClose: () => void;
}

const wrapperAnimation: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: { duration: 0.25 },
  },
};

const containerAnimation: Variants = {
  initial: {
    top: '100%',
    opacity: 0,
  },
  animate: {
    top: '50%',
    opacity: 1,
    transition: { duration: 0.25, delay: 0.25 },
  },
};

function NotEnoughFundsModal({ onClose, open }: TNotEnoughFundsModalProps) {
  return (
    <AnimatePresence>
      {open && (
      <motion.div
        variants={wrapperAnimation}
        initial="initial"
        animate="animate"
        exit="initial"
        className="absolute inset-0 w-full h-full bg-black bg-opacity-80 z-[100]"
      >
        <motion.div
          className="
                absolute top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2
                not-enough-funds-modal-container
                max-w-[343px] w-full
                flex flex-col items-center
                p-4
                bg-notEnoughFundsModalBg
                gradient-border
                rounded-[20px]
                z-[0]
            "
          variants={containerAnimation}
          initial="initial"
          animate="animate"
          exit="initial"
        >
          <Button pureClass className="absolute right-5 top-5 cursor-pointer z-[1000]" onClick={onClose}>
            <CloseIco className="stroke-[#FFFFFF]" />
          </Button>
          <span className="font-Bangers text-[26px] leading-[27px]">
            Oh... it seems you don&apos;t
            <br />
            {' '}
            have enough coins.
          </span>
          <div className="relative max-w-[227px] w-full aspect-[1.28/1] z-[-1]">
            <img src={CoinGroupWithGlow} alt="coin-group" className="absolute top-1/2 -translate-y-1/2" />
          </div>
          <Link to={Pages.store}>Get More Coins</Link>
          <Link to={Pages.home} className="btn navy mt-2 py-4 text-[24px]">Spin the slot</Link>
        </motion.div>
      </motion.div>
      )}
    </AnimatePresence>
  );
}

export default NotEnoughFundsModal;
